import {create} from 'zustand';

interface ConfirmDialogState {
  isOpen: boolean;
  message: string;
  type: 'success' | 'info' | 'warning' | 'error';
  onConfirm?: () => void;
  onCancel?: () => void;
  showDialog: (message: string, type: 'success' | 'info' | 'warning' | 'error', onConfirm?: () => void) => void;
  closeDialog: () => void;
}

export const useConfirmDialogStore = create<ConfirmDialogState>((set) => ({
  isOpen: false,
  message: '',
  type: 'info',
  onConfirm: undefined,
  onCancel: undefined,
  showDialog: (message, type, onConfirm) => set({isOpen: true, message, type, onConfirm}),
  closeDialog: () => set({isOpen: false})
}));
